import { useHasuraClaim } from '@nhost/react'

export default function useIsAgencyMember(): boolean | undefined {
  const agencyMemberId = useHasuraClaim('agency-member-id')
  const isAgencyMember = !!agencyMemberId && agencyMemberId !== 'null'
  return isAgencyMember
}
